import { Tooltip as MuiTooltip } from "@mui/material";
import type { TooltipProps } from "@mui/material/Tooltip";
import { cloneElement, forwardRef, isValidElement, type ReactElement, type Ref } from "react";

const RefForwarder = forwardRef<unknown, { children: TooltipProps["children"] }>(({ children, ...rest }, ref) => {
    if (isValidElement(children)) {
        return cloneElement(children as ReactElement, { ...rest, ref });
    }
    return (
        <span ref={ref as Ref<HTMLSpanElement>} style={{ display: "contents" }} {...rest}>
            {children}
        </span>
    );
});
RefForwarder.displayName = "RefForwarder";

export const Tooltip = ({ children, ...props }: TooltipProps) => (
    <MuiTooltip {...props}>
        <RefForwarder>{children}</RefForwarder>
    </MuiTooltip>
);
